<template>
  <div>
    <div>
      <div v-if="this.loaded && this.destinations.length === 0">
        <div class="alert alert-primary" role="alert">
          مقصدی یافت نشد، برای افزودن مقصد
          <router-link
            :to="{ name: 'destinations-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <b-overlay :show="!loaded" opacity="0.4">
      <div
        class="d-flex flex-wrap justify-content-center justify-content-md-start"
      >
        <div
          v-for="destination in destinations"
          style="min-width: 130px; max-width: 170px"
          :key="destination.id"
          class="card card-custom destination-card m-2 text-center"
        >
          <router-link
            :to="{ name: 'destinations-show', params: { id: destination.id } }"
          >
            <div class="card-body p-4">
              <div class="symbol symbol-40 text-center">
                <img
                  class="mx-auto"
                  :alt="destination.name"
                  :src="
                    `/media/destinations/${
                      destinationTypes[destination.type]
                    }.png`
                  "
                />
              </div>
              <div class="mt-4 font-size-sm">
                {{ destination.name }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </b-overlay>

    <div
      class="overflow-auto mt-5"
      v-if="
        destinationsPagination.lastPage > 1 ||
          destinationsPagination.currentPage > 1
      "
    >
      <b-pagination
        v-model="destinationsPagination.currentPage"
        :total-rows="destinationsPagination.total"
        :per-page="destinationsPagination.perPage"
        aria-controls="my-table"
        @input="updateDestinations()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_DESTINATIONS } from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";

export default {
  name: "destinations",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "مقصد‌ها" }]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "destinations-create" },
          class: "btn-primary"
        }
      ]
    });
    this.updateDestinations();
  },
  computed: {
    ...mapGetters([
      "destinations",
      "destinationsPagination",
      "destinationTypes"
    ])
  },
  methods: {
    updateDestinations() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_DESTINATIONS, {
          editable: true
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
